import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefSentDocumentErrorsQuery, KsefSentDocumentErrorsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefSentDocumentErrorsQuery)
@Wrapper(KsefSentDocumentErrorsQueryHandlerBase)
export class KsefSentDocumentErrorsQueryHandler {
    public constructor(
        http: Http
    ) { }
}
